<template>
	<div class="reviewTaskManage">
		<el-container>
			<headTop :data="'/recordReview/reviewTaskManage'"></headTop>
			<!-- 路由匹配到的组件将显示在这里 -->
			<router-view />
			<el-footer>
				<foot></foot>
			</el-footer>
		</el-container>
	</div>
</template>
<script>

export default {
	data() {
		return {
			
		};
	},
	created() {
	},
	methods: {
		//切换导航
		handleSelect(key, keyPath) {
			console.log(key, keyPath);
		},
	},
	watch: {},
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/mixin.scss"; //定义方法
.reviewTaskManage {
	background: $bodyColor;
}
// 头部
.header{
	@include theme();
}
.header /deep/ {
	height: 84px !important;
	line-height: 84px;
	.title {
		// @include fontSize($fz24, $num);
		font-size: 36px;
		color: $cfff;
	}
	.welcome {
		@include fontSize($fz12, $num);
		color: $cd0dcfb;
	}
	// 导航
	&>.el-menu {
		background: transparent !important;
		float: left;
		.iconfont {
			position: absolute;
			bottom: 16px;
			left: 50%;
			margin-left: -6px;
			@include fontSize($fz12, $num);
			color: $c7ca1fa;
			line-height: 0px;
			display: none;
		}
		.el-submenu .el-menu-item{
			border-bottom:1px dashed #d4d2d2;
			&:last-child{
				border:none;
			}
		}
		.el-menu--horizontal{
			left:4px!important;
			.el-menu-item{
				line-height: 36px;
				height: 36px;
			}
		}
	}
	.el-menu-demo1{
		margin-left: 6%;
	}
	&>.el-menu>.el-menu-item,
	.el-submenu__title {
		@include fontSize($fz18, $num);
		color: $c7ca1fa;
		position: relative;
	}
	.el-submenu {
		position: relative;
	}
	.el-menu.el-menu--horizontal,
	.el-menu--horizontal > .el-menu-item {
		border: none;
	}
	.el-menu--horizontal > .el-menu-item,
	.el-menu--horizontal > .el-submenu .el-submenu__title {
		height: 84px;
		line-height: 84px;
		color: $c7ca1fa;
		border-bottom:none;
	}
	.el-menu--horizontal > .el-submenu .el-submenu__title {
		position: relative;
	}
	.el-menu--horizontal > .el-menu-item.is-active {
		border: none;
		color: $cfff;
		.iconfont {
			color: $cfff;
			display: block;
		}
	}
	.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
	.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
	.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
		background: transparent;
		color: $cfff;
		.iconfont {
			color: $cfff;
			display: block;
		}
	}
	.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
		display: none;
	}
	.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
		border-bottom: none;
		color: $cfff;
	}
	.el-submenu.is-active{
		.iconfont {
			color: $cfff;
			display: block;
		}
	}
	//更多操作
	.el-menu-demo2{
		float: right;		
		// margin-right:10%;
		.iconfont{
			display:block;
			@include fontSize($fz30, $num);
			color:$cfff;
			bottom:40px;
		}
	}
}

//侧边
.el-aside {
	background-color: #d3dce6;
	color: #333;
	text-align: center;
	line-height: 200px;
	overflow: inherit;
	min-height: calc(100vh - 210px);
	width: 280px;
	align-items: stretch;
	position: relative;
}
//中间内容
.el-main {
	background:transparent;
	color: #333;
	text-align: center;
	min-height: calc(100vh - 210px);
	h2 {
		@include fontSize($fz16, $num);
	}
	p {
		@include fontSize($fz12, $num);
	}
}
// 底部
.el-footer {
	height: auto !important;
	@include theme();
}

</style>